import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";
import { sortStatesByCustomerJurisdictions } from "../services/stateSorter";

const initialValues = createDefaultInitialState([]);

export const statesReducer = createReducerFromMap(initialValues, {
    ...createAsyncReducer("GET_STATES", (state, action) => {
        const states = action.value.states.map(x => x.key);
        return sortStatesByCustomerJurisdictions(states, action.value.customerJurisdictions);
    }),
});
